import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states/dashboard';

function createRangeSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectRange = createSelector(dashboardFeatureSelector, (state: IDashboardState) => state.range);

  return {
    selectRange,
  };
}

export default createRangeSelectors;
